import * as React from 'react';

import { formatMessageHelper, FormattedMessageHelper } from '../../shared/helpers/internationalization';
import ChartContainer from '../AlphaChart/ChartContainer';
import { ImmutableInterface } from '../../types';

import PerformanceTable from './PerformanceTable';
import PerformanceStats from './PerformanceStats';

import Immutable from 'immutable';
import { IntlShape } from 'react-intl';

export interface PerformanceComparisonCompetition {
  id: string;
  name: string;
  scoring: string;
}

interface PerformanceComparisonMainProps {
  delay: number;
  path: string[];
  hasData: boolean;
  size?: number;
  shouldResize?: number;
  position?: string;
  alphaDetail?: Immutable.Collection<string, any>;
  partition?: string[];
  intl: IntlShape;
  competition: ImmutableInterface<PerformanceComparisonCompetition> | null;
}

const partitionKeyMapping = {
  REGULAR: 'performance.partition.regular',
  SUPER: 'performance.partition.super',
  EQUITY: 'performance.partition.equity',
  '0': 'performance.partition.0',
  '1': 'performance.partition.1',
};

const PerformanceComparisonMain = ({
  delay,
  path,
  hasData,
  size,
  shouldResize,
  position = 'odd',
  alphaDetail,
  partition = [],
  intl,
  competition,
}: PerformanceComparisonMainProps) => {
  if (hasData && alphaDetail) {
    const partitionValues = partition?.map(key => {
      if (key === 'competition') return competition?.get('name');
      return alphaDetail.getIn(key.split('.'));
    });

    const localePartitionValues = {
      partitions: partitionValues // @ts-ignore
        .map(val => (val in partitionKeyMapping ? formatMessageHelper(intl, partitionKeyMapping[val]) : val))
        .join(', '),
    };

    return (
      <div>
        <PerformanceStats path={path.concat(['alphaDetail', 'performanceStats'])} />
        <div className="performance-comparison--title">
          <FormattedMessageHelper id="is.performance.comparison" values={localePartitionValues} />
        </div>
        <div className="performance-comparison--subtitle">
          <FormattedMessageHelper id="is.performance.comparison.subtitle" values={localePartitionValues} />
        </div>
        <PerformanceTable path={path.concat(['alphaDetail', 'performanceTable'])} />
        <div className="performance-comparison--title">
          <FormattedMessageHelper id="is.performance.comparison.pnl" values={{ delay: delay }} />
        </div>
        <ChartContainer
          path={path.concat(['alphaDetail', 'performancePnl'])}
          id="alphas-performanceComparison"
          position={position}
          showAllAndNoneButtons={false}
          size={size}
          shouldResize={shouldResize}
          addId={false}
        />
      </div>
    );
  } else {
    return (
      <div className="chart__no-results">
        <FormattedMessageHelper id="chart.noResults" />
      </div>
    );
  }
};

export default PerformanceComparisonMain;
